// 1237 수시 근골격계 부담작업 유해요인조사 — 목록
// 검색: 작성일 / 조사구분 / 검색조건(키워드) / 부서명(gnsc 고정 "과" 목록, 사업장의 com_name 으로 필터)
// 컬럼: 부서명 / 팀명 / 사업장명 / 조사구분 / 조사일시 / 작업공정명 / 작성일
const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select",
        label: "조사구분",
        value: "surveyType",
        query: { st: "surveyType" },
        options: {
          default: "",
          items: [
            { text: "전체", value: "" },
            { text: "정기조사", value: "정기조사" },
            { text: "수시조사", value: "수시조사" },
          ],
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["부서명", "팀명", "조사구분", "조사일시", "작성일"] },
      },
      {
        component: "search-select-company-name",
        label: "부서명",
        value: "companyName",
        query: { cName: "companyName" },
        options: {
          default: "",
          targetKey: "body.stdInfo.부서명_과",
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  조사구분 (Write 에서 저장하는 요약 문자열 "정기조사, 수시조사" 에 대해 LIKE 검색)
    if (search.surveyType) {
      conditions.push({ key: "body.조사구분요약", operator: "LIKE", value: `%${search.surveyType}%` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "부서명", key: "field.com_name", sortKey: false },
      { name: "팀명", key: "field.team_company_list[%].com_name", sortKey: false },
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "조사구분", key: "body.조사구분요약" },
      { name: "조사일시", key: "body.조사정보.조사일시" },
      { name: "작업공정명", key: "body.조사정보.작업공정명" },
      { name: "작성일", key: "created_at" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const body = func.getContent(value);
      switch (index) {
      case 0: {
        const meta = JSON.parse((value.field && value.field.meta) || "{}");
        return (body.stdInfo && body.stdInfo.부서명_과) || meta.com_name || "-"; // 부서명
      }
      case 1: {
        const teamCompanyList = JSON.parse((value.field && value.field.meta) || "{}").team_company_list;
        return teamCompanyList && teamCompanyList.length > 0 ? teamCompanyList.map((team) => team.com_name).join(", ") : "-"; // 팀명
      }
      case 2:
        return body.stdInfo ? body.stdInfo.field_name : ""; // 사업장명
      case 3:
        return body.조사구분요약 || "-"; // 조사구분
      case 4:
        return body.조사정보 ? body.조사정보.조사일시 : ""; // 조사일시
      case 5:
        return body.조사정보 ? body.조사정보.작업공정명 : ""; // 작업공정명
      case 6:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
};
export default list;
